import { Blocks } from 'lucide-react';

export const IntegrationsIcon = ({
  withMargin,
  variant,
}: {
  withMargin?: boolean;
  variant?: 'default' | 'white' | 'orange';
}) => {
  const textColor =
    variant === 'white'
      ? 'text-white'
      : variant === 'orange'
        ? 'text-orange-500'
        : 'text-black';
  return (
    <Blocks
      className={`${withMargin ? 'ml-4 mr-4' : ''} h-4 w-4 ${textColor}`}
    />
  );
};
